import * as actionTypes from "../constants";

import type { EncounterImportExportFormatsState } from "../models";

const createEncounterImportExportFormatsState = (): EncounterImportExportFormatsState => ({
  formats: null,
});

export const encounterImportExportFormatsReducer = (
  state = createEncounterImportExportFormatsState(),
  action,
) => {
  switch (action.type) {
    case actionTypes.ENCOUNTER_IMPORT_EXPORT_SET_FORMATS:
      return {
        ...state,
        formats: action.payload,
      };
    default:
      return state;
  }
};
